<template>
  <div class="calm__filterbar">
    <div class="calm__filter-grid" :style="gridStyle">
      <slot />

      <div v-if="!hideActions" class="fld">
        <label class="calm__fld-spacer" aria-hidden="true">&nbsp;</label>
        <div class="calm__filter-actions">
          <calm-button
            v-if="showReset"
            variant="ghost"
            :icon="resetIcon"
            @click="$emit('reset')"
          >{{ resetLabel }}</calm-button>
          <calm-button
            variant="primary"
            :icon="searchIcon"
            :loading="loading"
            @click="$emit('search')"
          >{{ searchLabel }}</calm-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CalmButton from "./CalmButton.vue";

export default {
  name: "calm-filter-bar",
  components: { CalmButton },
  props: {
    searchLabel: { type: String, default: "ค้นหา" },
    resetLabel: { type: String, default: "ล้าง" },
    searchIcon: { type: String, default: "" },
    resetIcon: { type: String, default: "" },
    showReset: { type: Boolean, default: true },
    hideActions: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    // override the filter-grid template (e.g. "repeat(3,1fr) auto")
    columns: { type: String, default: null },
  },
  computed: {
    gridStyle() {
      return this.columns ? { gridTemplateColumns: this.columns } : null;
    },
  },
};
</script>

<style scoped>
/* trailing-action field aligns its buttons to the grid baseline (label spacer
   keeps it level with the input fields' bottom edge). Namespaced; additive. */
.calm__fld-spacer { visibility: hidden; }
.calm__filter-actions {
  display: flex;
  gap: 8px;
  align-items: center;
}
</style>
